import { callables as billingDetailsCallables } from "./billingDetails/callables";
import { callables as invoicesCallables } from "./invoices/callables";
import { callables as metadataCallables } from "./metadata/callables";
import { callables as paymentMethodsCallables } from "./paymentMethods/callables";
import { callables as plansCallables } from "./plans/callables";
import { callables as promosCallables } from "./promos/callables";
import { callables as subscriptionsCallables } from "./subscriptions/callables";

export const apiName = "workspaces";

export const callables = {
    ...billingDetailsCallables,
    ...invoicesCallables,
    ...metadataCallables,
    ...paymentMethodsCallables,
    ...plansCallables,
    ...promosCallables,
    ...subscriptionsCallables
};
